module.exports = __webpack_public_path__ + "static/rectangle-320d1b28e88eff78aac54471aab1143b.png";